<template>
  <LayoutHeader main="email" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article>
      <form @submit.prevent="submit()" v-if="step == 'input'">
        <h1 class="text-center mb-4">メールアドレスの変更</h1>

        <div class="text-center mb-4 text-sub">
          {{ me.email }}
        </div>

        <div class="mb-3">
          <label for="email" class="form-label fw-bold">新しいメールアドレス</label>
          <input type="email" class="form-control" :class="{'is-invalid': emailChangeError}" id="email" ref="email" v-model="email" placeholder="sample@example.com" required />
          <div class="invalid-feedback">
            すでに登録されているメールアドレスです。
          </div>
        </div>
        <div class="mb-5">
          <button type="submit" class="btn btn-danger w-100 fw-bold">変更確認メールを送信</button>
        </div>
        <div class="mb-5 text-center">
          <router-link class="text-decoration-underline" :to="{ name: 'Account' }">戻る</router-link>
        </div>
      </form>
      <div v-else-if="step == 'submited'">
        <h1 class="text-center">確認メールを送信しました</h1>

        <div class="mb-5 text-center">
          新しいメールアドレスに変更確認メールを送信しました。メールを確認してリンクを開いてください。
        </div>
        <div class="mb-5 text-center">
          <router-link class="text-decoration-underline" :to="{ name: 'Account' }">戻る</router-link>
        </div>
      </div>
    </article>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      titlePrefix: 'メールアドレスの変更',
      step: 'input',
      email: '',
      emailChangeError: false,
    }
  },
  methods: {
    submit() {
      const data = {
        email: this.email,
      };
      this.loadingOverlay = true;
      this.emailChangeError = false;
      this.axios({
        url: '/email',
        method: 'post',
        data: data,
      }).then(res => {
        this.loadingOverlay = false;
        if (res.data.error) {
          this.emailChangeError = true;
          return;
        }
        this.step = 'submited';
      });
    },
  },
}
</script>


